import { render } from "./VabeneAddTimeSlotPage.vue?vue&type=template&id=6dca3cbc&ts=true"
import script from "./VabeneAddTimeSlotPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddTimeSlotPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__